module.exports = __webpack_public_path__ + "static/media/rashmita-chakraborty.eaae81a7.jpg";